// extracted by mini-css-extract-plugin
export default {"container":"PatientCalendarPage_container__05NOu","iframeWrapper":"PatientCalendarPage_iframeWrapper__BHaIc","iframe":"PatientCalendarPage_iframe__7XLqd"};